import moment from 'moment'
export default {
  inject: [
    '$utils'
  ],
  methods: {
    newCustomModel () {
      return [{
        startDate: '',
        endDate: '',
        startTime: '',
        duration: 86400,
        repeatDays: []
      }]
    },
    /**
    * This will get start date from date range element value
    * @param {Array} dateRange
    */
    getStartDateFromDateRange (dateRange) {
      if ((dateRange instanceof Array) && (dateRange.length > 1)) {
        return dateRange[0]
      }
      return ''
    },
    /**
     * This will get end date from date range element value
     * @param {Array} dateRange - date range value
     */
    getEndDateFromDateRange (dateRange) {
      if ((dateRange instanceof Array) && (dateRange.length > 1)) {
        return dateRange[1]
      }
      return ''
    },
    getStartTimeFromTimeRange (startTime, endTime) {
      const hasStartTime = this.$utils.isObject(startTime) || ((typeof startTime === 'string') && (startTime !== ''))
      const hasEndTime = this.$utils.isObject(endTime) || ((typeof endTime === 'string') && (endTime !== ''))

      // Set start time to 00:00 if start time is empty but end time is not empty
      if (!hasStartTime && hasEndTime) {
        return moment().set({ hour: '00', minute: '00', second: '00' }).format('HH:mm:ss')
      }

      if (hasStartTime) {
        return moment(startTime).set({ second: '00' }).format('HH:mm:ss')
      }

      return null
    },
    /**
     * This will calculate duration between startTime and endTime
     * @param {String} startTime
     * @param {String} endTime
     */
    calculateDurationFromTimeRange (startTime, endTime) {
      const hasStartTime = this.$utils.isObject(startTime) || ((typeof startTime === 'string') && (startTime !== ''))
      const hasEndTime = this.$utils.isObject(endTime) || ((typeof endTime === 'string') && (endTime !== ''))
      const defaultDuration = 86400
      let newStartTime = '00:00:00'
      let newEndTime = ''

      // Duration should be set if schedule has NO start time and end time
      if (!hasStartTime && !hasEndTime) {
        return undefined
      }

      // Format start time with 00 second as API requirement
      if (hasStartTime) {
        newStartTime = moment(startTime).set({ second: '00' }).format('HH:mm:ss')
      }

      // Format end time with 00 second as API requirement
      if (hasEndTime) {
        newEndTime = moment(endTime).set({ second: '00' }).format('HH:mm:ss')
      }

      // Caculate Duration with End Date
      if (newEndTime !== '') {
        const today = moment().format('YYYY-MM-DD')

        // End time is within the day
        if (newStartTime < newEndTime) {
          const startDateAndTime = moment(`${today} ${newStartTime}`)
          const endDateAndTime = moment(`${today} ${newEndTime}`)
          const calcDuration = moment.duration(
            endDateAndTime.diff(startDateAndTime)
          ).asSeconds()
          return calcDuration
        }

        // End time as on the next day
        if (newStartTime > newEndTime) {
          const nextDay = moment().add(1, 'days').format('YYYY-MM-DD')
          const startDateAndTime = moment(`${today} ${newStartTime}`)
          const endDateAndTime = moment(`${nextDay} ${newEndTime}`)
          const calcDuration = moment.duration(
            endDateAndTime.diff(startDateAndTime)
          )
            .asSeconds()
          return calcDuration
        }

        // End time is the same with start time
        if (newStartTime === newEndTime) {
          return defaultDuration
        }
      }

      if (newEndTime === '') {
        const today = moment()
        const startDateAndTime = moment(`${today.clone().format('YYYY-MM-DD')} ${newStartTime}`)
        const endDateAndTime = today.clone().add(1, 'days').set({ hour: '00', minute: '00', second: '00' })
        const calcDuration = moment.duration(endDateAndTime.diff(startDateAndTime)).asSeconds()

        return Math.trunc(calcDuration)
      }
    },
    createStartTimeFromAPIFormat (customData) {
      if (customData.startTime) {
        const today = moment().format('YYYY-MM-DD')
        const startDate = moment(`${today} ${customData.startTime}`)

        if (startDate.format('HH:mm:ss') === '00:00:00') {
          return moment().set({ hour: '00', minute: '00', second: '00' })
        }
        // Converted to new Date as per element ui time picker requirement
        return new Date(startDate.format())
      }

      return ''
    },
    createEndTimeFromAPIFormat (customData) {
      let startDateAndTime = moment().set({ hours: '00', minutes: '00', seconds: '00' })
      if (customData.startTime) {
        const today = moment().format('YYYY-MM-DD')
        startDateAndTime = moment(`${today} ${customData.startTime}`)
      }

      // Is schedule has no starttime then endTime should be empty
      if (!customData.startTime || (customData.startTime && (customData.startTime === '' || customData.startTime === null))) {
        return []
      }

      const endDateAndTime = startDateAndTime.add(customData.duration, 'seconds')
      if (endDateAndTime.format('HH:mm:ss') === '00:00:00') {
        return moment().set({ hour: '00', minute: '00', second: '00' })
      }

      // Converted to new Date as per element ui time picker requirement
      return new Date(endDateAndTime.format())
    },
    createDateRangeFromAPIData (customData) {
      if (customData.startDate && customData.endDate) {
        const dateRange = []
        dateRange.push(customData.startDate)
        dateRange.push(customData.endDate)
        return dateRange
      }
      return []
    },
    createCustomPlaytimeOrderValue (params) {
      if (typeof params === 'object') {
        if (params.createOrderType === 'newPlaytime') {
          return new Date().getTime().toString(16)
        }
      }

      return 0
    },
    createPlaytimeUIDByMedia (scheduleTarget, playtimePosition, mediaResourceId) {
      return `${scheduleTarget}-${playtimePosition}-${mediaResourceId}`
    },
    /**
     * Draw event times object for schedule slider
     * @param {Array} times - list of times
     * @param {Boolean} isSelected
     */
    filterScheduleTimes (times, isSelected) {
      const scheduleTimes = this.$utils.clone(times)

      for (const indx in scheduleTimes) {
        const time = scheduleTimes[indx]
        time._edit = {}

        if (typeof (isSelected) === 'boolean') {
          time._edit.isSelected = true
        }

        if (time.priority) {
          time._edit.showPriorityIcon = true
        }

        // Calculate duration in Hours and set start time details
        time._edit.durationInMinutes = time.duration / 60
        time._edit.startTime = moment(`${time.startDate} ${time.startTime}`).format('HH:mm')
        time._edit.startTimeHour = moment(`${time.startDate} ${time.startTime}`).format('HH')
        time._edit.startTimeMinute = moment(`${time.startDate} ${time.startTime}`).format('mm')

        // Caculate End time
        const startDateAndTime = moment(`${time.startDate} ${time.startTime}`)
        const endDateAndTime = moment(startDateAndTime).add(time.duration, 'seconds')

        time._edit.endTime = moment(endDateAndTime).format('HH:mm')
        time._edit.endTimeHour = moment(endDateAndTime).format('HH')
        time._edit.endTimeMinute = moment(endDateAndTime).format('mm')

        if (time._edit.endTime === '00:00') {
          time._edit.endTime = '24:00'
        }

        // Add uid
        time._edit.uid = `${time.startDate}_${time.startTime}_${time.duration}_${indx}`

        // Add Style
        let numOfPixelPerHour = 179
        const windowScreenSize = window.innerWidth

        if (windowScreenSize < 1920) {
          numOfPixelPerHour = 118
        }

        const numOfPixelPerMinute = numOfPixelPerHour / 60
        const styleBarWidth = time._edit.durationInMinutes * numOfPixelPerMinute
        const styleLeftPosition = (parseInt(time._edit.startTimeHour) * numOfPixelPerHour) +
          (parseInt(time._edit.startTimeMinute) * numOfPixelPerMinute)

        // Add Style
        time._edit.style = { width: `${styleBarWidth}px`, left: `${styleLeftPosition}px` }

        /* Add Text label
        - Duration with greater than 1 hour, show start and end time
        - Duration with less than 1 hour, show start time only
        - Duration with less than 30min, no text label
        */
        time._edit.textLabel = `${time._edit.startTime} - ${time._edit.endTime}`
        const min60 = 60
        const min30 = 30

        if (time._edit.durationInMinutes >= min30 && time._edit.durationInMinutes < min60) {
          time._edit.textLabel = `${time._edit.startTime} `
        } else if (time._edit.durationInMinutes < min30) {
          time._edit.textLabel = ''
        }
      }

      return scheduleTimes
    },
    createScheduleTimeTitle (scheduleTimeSrc, addParams) {
      const newTitle = { list: '24/7', range: '24/7' }
      if (!addParams) addParams = {}

      const scheduleTime = this.$utils.clone(scheduleTimeSrc)

      if (!scheduleTime.daily) {
        const hasRepeatDays = !!((Array.isArray(scheduleTime.repeatDays)) && scheduleTime.repeatDays.length)
        const hasStartDateAndEndDate = !!scheduleTime.startDate && !!scheduleTime.endDate
        const startTime = this.createStartTimeFromAPIFormat(scheduleTime)
        const endTime = this.createEndTimeFromAPIFormat(scheduleTime)
        const hasStartAndEndTime = !!startTime && !!endTime
        const repeatDaysTitleAsList = []
        let repeatDaysTitleAsRange = ''
        const daysTranslation = { mon: this.$t('label.mon'), tue: this.$t('label.tue'), wed: this.$t('label.wed'), thu: this.$t('label.thu'), fri: this.$t('label.fri'), sat: this.$t('label.sat'), sun: this.$t('label.sun') }

        // Translate repeat days
        if (hasRepeatDays) {
          const repeatDaysWithIndex = []
          scheduleTime.repeatDays.forEach((day) => {
            switch (day) {
              case 'mon' :
                repeatDaysWithIndex.push({ index: 0, day })
                break
              case 'tue' :
                repeatDaysWithIndex.push({ index: 1, day })
                break
              case 'wed' :
                repeatDaysWithIndex.push({ index: 2, day })
                break
              case 'thu' :
                repeatDaysWithIndex.push({ index: 3, day })
                break
              case 'fri' :
                repeatDaysWithIndex.push({ index: 4, day })
                break
              case 'sat' :
                repeatDaysWithIndex.push({ index: 5, day })
                break
              case 'sun' :
                repeatDaysWithIndex.push({ index: 6, day })
                break
            }
          })
          const sortRepeatDays = repeatDaysWithIndex.sort((a, b) => {
            if (a.index < b.index) return -1
            if (a.index > b.index) return 1
            return 0
          })

          // Create Repeat days as list title
          sortRepeatDays.forEach((day) => {
            repeatDaysTitleAsList.push(daysTranslation[day.day])
          })

          // Create Repeat days as range title
          const weekDaysMap = new Map([
            ['mon', 0],
            ['tue', 1],
            ['wed', 2],
            ['thu', 3],
            ['fri', 4],
            ['sat', 5],
            ['sun', 6]
          ])
          const getDayRanges = (days) => {
            const ranges = []

            let range = [days[0]]
            let d = weekDaysMap.get(days[0])

            for (let i = 1; i < days.length; i++) {
              if (d !== (d = weekDaysMap.get(days[i])) - 1) {
                range.push(days[i - 1])
                ranges.push(range)
                range = [days[i]]
              }
            }
            range.push(days[days.length - 1])
            ranges.push(range)

            return ranges
          }

          const sortDaysRange = []
          sortRepeatDays.forEach((day) => { sortDaysRange.push(day.day) })
          repeatDaysTitleAsRange = getDayRanges(sortDaysRange).map((r) => {
            // Translate days
            if (r[0]) r[0] = daysTranslation[r[0]] ? daysTranslation[r[0]] : r[0]
            if (r[1]) r[1] = daysTranslation[r[1]] ? daysTranslation[r[1]] : r[1]
            let res = r.join(' - ')

            // Remove dash if start and end range is the same
            if (r[0] === r[1]) res = r[0]

            return res
          }).join(', ')
        }

        // Set Date
        let playtimeTitle = ''
        let playtimeTitleRepeatDaysAsRange = ''
        if (hasStartDateAndEndDate) {
          const startDateMoment = moment(scheduleTime.startDate)
          const enDateMoment = moment(scheduleTime.endDate)
          const isStartDateAndEndDateMonthTheSame = startDateMoment.clone().format('MM') === enDateMoment.clone().format('MM')
          const isStartDateAndEndDateDayTheSame = startDateMoment.clone().format('DD') === enDateMoment.clone().format('DD')
          const isStartDateAndEndDateYearTheSame = startDateMoment.clone().format('YYYY') === enDateMoment.clone().format('YYYY')
          const isStartDateAndEndDateYearTheSameFromCurrentYear = (startDateMoment.clone().format('YYYY') === moment().format('YYYY')) && (enDateMoment.clone().format('YYYY') === moment().format('YYYY'))
          const startDateMonthLbl = `${this.$t(`el.datepicker.months.${startDateMoment.clone().format('MMM').toLowerCase()}`)}`
          const startDateDayLbl = startDateMoment.clone().format('DD')
          const startDateYearLbl = startDateMoment.clone().format('YYYY')
          const endDateMonthLbl = `${this.$t(`el.datepicker.months.${enDateMoment.clone().format('MMM').toLowerCase()}`)}`
          const endDateDayLbl = enDateMoment.clone().format('DD')
          const endDateYearLbl = enDateMoment.clone().format('YYYY')

          // The same year
          if (isStartDateAndEndDateYearTheSame) { // The same year
            if (isStartDateAndEndDateMonthTheSame) { // The same month
              playtimeTitle = startDateDayLbl

              if (!isStartDateAndEndDateDayTheSame) {
                playtimeTitle = `${playtimeTitle}-${endDateDayLbl}`
              }

              playtimeTitle = `${playtimeTitle} ${startDateMonthLbl}`
            } else {
              playtimeTitle = `${startDateDayLbl} ${startDateMonthLbl} - ${endDateDayLbl} ${endDateMonthLbl}`
            }

            // Target Year is the same from current year then add the year
            if (!isStartDateAndEndDateYearTheSameFromCurrentYear) {
              playtimeTitle += ` ${startDateYearLbl}`
            }
          } else {
            playtimeTitle = `${startDateDayLbl} ${startDateMonthLbl} ${startDateYearLbl} - ${endDateDayLbl} ${endDateMonthLbl} ${endDateYearLbl}`
          }
        }

        playtimeTitleRepeatDaysAsRange = playtimeTitle

        // Set Days
        if (hasRepeatDays) {
          const daysLabel = repeatDaysTitleAsList.join(', ')
          const daysLabelAsRange = repeatDaysTitleAsRange

          playtimeTitle += (playtimeTitle.length) ? ` | ${daysLabel}` : daysLabel
          playtimeTitleRepeatDaysAsRange += (playtimeTitleRepeatDaysAsRange.length) ? ` | ${daysLabelAsRange}` : daysLabelAsRange
        }

        if (hasStartAndEndTime) {
          const timeFormat = addParams.timeFormat ?? 'HH:mm'

          const timeLabel = `${moment(startTime).format(timeFormat)}-${moment(endTime).format(timeFormat)}`

          if (timeLabel !== '00:00-00:00') {
            playtimeTitle += (playtimeTitle.length) ? ` | ${timeLabel}` : timeLabel
            playtimeTitleRepeatDaysAsRange += ((playtimeTitleRepeatDaysAsRange.length) ? ` | ${timeLabel}` : timeLabel)
          }
        }

        newTitle.list = (playtimeTitle.length) ? playtimeTitle : '24/7'
        newTitle.range = (playtimeTitleRepeatDaysAsRange.length) ? playtimeTitleRepeatDaysAsRange : '24/7'
      }

      return newTitle
    },
    createNewPlaytimeForSchedulePage (params) {
      if (!params) params = {}

      if (params.schedulePage) {
        const scheduleItemFullDetails = this.$utils.clone(params.scheduleItemFullDetails)
        const newPlayTimeIdx = params.playTimeIndx
        const newPlaytimeVal = {
          daily: true,
          order: this.$utils.calculateSortOrderValue({ mediaIndex: newPlayTimeIdx }),
          uid: `${this.$utils.generateUniqueID()}-${newPlayTimeIdx}`,
          adds: params.isForSmartTags ? { repeat: 1 } : false
        }
        const newAddedMediaItem = params.media

        // Adjust order value for audio
        if (newAddedMediaItem.type && ['audio-playlist', 'audio'].indexOf(newAddedMediaItem.type) >= 0) {
          if (params.regularSchedule && scheduleItemFullDetails.events.length) {
            const allAudioIndx = []
            scheduleItemFullDetails.events.forEach((event, indx) => { if (event.audio) allAudioIndx.push(indx) })
            const lastAudioIndx = allAudioIndx.length ? allAudioIndx.length - 1 : null

            if (lastAudioIndx !== null) {
              const lastAudioOrderValue = scheduleItemFullDetails.events[lastAudioIndx].order
              const bottomMediaOrderOfLastAudio = scheduleItemFullDetails.events[lastAudioIndx + 1] ? scheduleItemFullDetails.events[lastAudioIndx + 1].order : null

              if (lastAudioOrderValue && bottomMediaOrderOfLastAudio) { // middle of the list
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ topSiblingOrder: lastAudioOrderValue, bottomSiblingOrder: bottomMediaOrderOfLastAudio })
              } else if (lastAudioOrderValue && !bottomMediaOrderOfLastAudio) { // bottom of the list
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ topSiblingOrder: lastAudioOrderValue, bottomSiblingOrder: false })
              }
            } else {
              const firstMediaOrderValue = scheduleItemFullDetails.events[0] ? scheduleItemFullDetails.events[0].order : null
              newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ forceToTop: true, previousOrderVal: firstMediaOrderValue })
            }
          }
        }

        // Adjust order value for overlay
        if (newAddedMediaItem.skin) {
          if (params.regularSchedule && scheduleItemFullDetails.events.length) {
            const allOverlayIndx = []
            scheduleItemFullDetails.events.forEach((event, indx) => { if (event.skin) allOverlayIndx.push(indx) })
            const lastOverlayIndx = allOverlayIndx.length ? allOverlayIndx.length - 1 : null

            if (lastOverlayIndx !== null) {
              const lastOverlayOrderValue = scheduleItemFullDetails.events[lastOverlayIndx].order
              const bottomMediaOrderOfLastAudio = scheduleItemFullDetails.events[lastOverlayIndx + 1] ? scheduleItemFullDetails.events[lastOverlayIndx + 1].order : null

              if (lastOverlayOrderValue && bottomMediaOrderOfLastAudio) { // middle of the list
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ topSiblingOrder: lastOverlayOrderValue, bottomSiblingOrder: bottomMediaOrderOfLastAudio })
              } else if (lastOverlayOrderValue && !bottomMediaOrderOfLastAudio) { // bottom of the list
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ topSiblingOrder: lastOverlayOrderValue, bottomSiblingOrder: false })
              }
            } else {
              const allAudioIndx = []
              scheduleItemFullDetails.events.forEach((event, indx) => { if (event.audio) allAudioIndx.push(indx) })
              const lastAudioIndx = allAudioIndx.length ? allAudioIndx.length - 1 : null

              // Check if has audio
              if (lastAudioIndx !== null) {
                const lastAudioOrderValue = scheduleItemFullDetails.events[lastAudioIndx].order
                const bottomMediaOrderOfLastAudio = scheduleItemFullDetails.events[lastAudioIndx + 1] ? scheduleItemFullDetails.events[lastAudioIndx + 1].order : null
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ topSiblingOrder: lastAudioOrderValue, bottomSiblingOrder: bottomMediaOrderOfLastAudio })
              } else {
                const firstMediaOrderValue = scheduleItemFullDetails.events[0] ? scheduleItemFullDetails.events[0].order : null
                newAddedMediaItem.order = this.$utils.calculateSortOrderValue({ forceToTop: true, previousOrderVal: firstMediaOrderValue })
              }
            }
          }
        }

        // If selected date from calendar is not today, then set specific date
        const getSchedStart = moment(scheduleItemFullDetails.sideBar.selectedDay.fullDate).set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DD[T]HH:mm:ss')
        if (!moment().isSame(moment(getSchedStart), 'day')) {
          delete newPlaytimeVal.daily

          newPlaytimeVal.startDate = moment(this.selectedDay.fullDate).format('YYYY-MM-DD')
          newPlaytimeVal.startTime = '00:00'
          newPlaytimeVal.endDate = moment(this.selectedDay.fullDate).format('YYYY-MM-DD')
          newPlaytimeVal.duration = 86400
          newPlaytimeVal.repeatDays = []
        }

        return newPlaytimeVal
      }
    }
  }
}
